import { Space } from "antd"
import { CountDown, Image, Modal, Skeleton, Spinner, Text } from "components/common"
import { performDecryption } from "configs/utils"
import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

const ScanQrCode = forwardRef(
  ({ useQuery, title, description, isTimeBound, reFetchApiWhenExpires, requiresDecryption }, ref) => {
    const { t } = useTranslation()
    const user = useSelector(state => state.app.user?.info)

    const [getQrCode, { data, isLoading, isFetching, error, isError }] = useQuery()

    const modalRef = useRef()
    const [open, setOpen] = useState(false)

    useImperativeHandle(
      ref,
      () => ({
        setVisible(value) {
          setOpen(value)
          modalRef?.current?.setVisible(value)
        },
      }),
      []
    )

    const onModalVisible = () => {
      getQrCode({ userId: user?.uuid })
    }

    return (
      <Modal
        title={t(`${title}`)}
        ref={modalRef}
        open={open}
        width={500}
        footerAlert={error}
        onModalVisible={onModalVisible}
        hideCancelButton={true}
        onCancel={() => {
          modalRef?.current?.setVisible(false)
          ref?.current?.setVisible(false)
        }}
        destroyOnClose
        onModalClos
        footer={!error && null}
      >
        <Space direction="vertical" align="center" className="w-100 text-center p-12" size={24}>
          <Text>{t(`${description}`)}</Text>
          {isFetching ? (
            <Spinner />
          ) : (
            data?.qrCode && (
              <Image
                src={requiresDecryption ? performDecryption(data?.qrCode) : data?.qrCode}
                preview={false}
                alt="qr-code-login"
                height={300}
                width={300}
              />
            )
          )}
          {isTimeBound && data?.exp && !isFetching && (
            <div style={{ textAlign: "center" }}>
              <Text type="secondary">
                {t("This QR code will expire after")}
                <CountDown
                  value={Date.now() + data?.exp * 1000}
                  onFinish={() => {
                    reFetchApiWhenExpires && getQrCode({ userId: user?.uuid })
                  }}
                  format="ss"
                />
                {t("seconds") + "."}
              </Text>
            </div>
          )}
        </Space>
      </Modal>
    )
  }
)

export default ScanQrCode
